/*
 * IMP-49 — POA Designation
 * String values mirror the future BE C# enum member names. The state→designation
 * map below is the authoritative default-by-state lookup used by the POA dropdown.
 */

export const POA_DESIGNATION = Object.freeze({
  Agent: 'Agent',
  AttorneyInFact: 'AttorneyInFact',
});

export const POA_CONTACT_HINT = 'Used when the POA eSigns for this borrower';

export const POA_DESIGNATION_OPTIONS = [
  { name: 'as Agent', value: POA_DESIGNATION.Agent },
  { name: 'Attorney-in-Fact', value: POA_DESIGNATION.AttorneyInFact },
];

export const STATE_TO_POA_DESIGNATION = Object.freeze({
  AL: POA_DESIGNATION.Agent,
  AR: POA_DESIGNATION.Agent,
  CO: POA_DESIGNATION.Agent,
  CT: POA_DESIGNATION.Agent,
  DC: POA_DESIGNATION.Agent,
  GA: POA_DESIGNATION.Agent,
  HI: POA_DESIGNATION.Agent,
  ID: POA_DESIGNATION.Agent,
  IA: POA_DESIGNATION.Agent,
  KY: POA_DESIGNATION.Agent,
  ME: POA_DESIGNATION.Agent,
  MD: POA_DESIGNATION.Agent,
  MI: POA_DESIGNATION.Agent,
  MT: POA_DESIGNATION.Agent,
  NE: POA_DESIGNATION.Agent,
  NV: POA_DESIGNATION.Agent,
  NH: POA_DESIGNATION.Agent,
  NM: POA_DESIGNATION.Agent,
  NC: POA_DESIGNATION.Agent,
  OH: POA_DESIGNATION.Agent,
  PA: POA_DESIGNATION.Agent,
  SC: POA_DESIGNATION.Agent,
  SD: POA_DESIGNATION.Agent,
  TX: POA_DESIGNATION.Agent,
  UT: POA_DESIGNATION.Agent,
  VA: POA_DESIGNATION.Agent,
  WA: POA_DESIGNATION.Agent,
  WV: POA_DESIGNATION.Agent,
  WI: POA_DESIGNATION.Agent,
  WY: POA_DESIGNATION.Agent,
  AK: POA_DESIGNATION.AttorneyInFact,
  AZ: POA_DESIGNATION.AttorneyInFact,
  CA: POA_DESIGNATION.AttorneyInFact,
  DE: POA_DESIGNATION.AttorneyInFact,
  FL: POA_DESIGNATION.AttorneyInFact,
  IL: POA_DESIGNATION.AttorneyInFact,
  IN: POA_DESIGNATION.AttorneyInFact,
  KS: POA_DESIGNATION.AttorneyInFact,
  LA: POA_DESIGNATION.AttorneyInFact,
  MA: POA_DESIGNATION.AttorneyInFact,
  MN: POA_DESIGNATION.AttorneyInFact,
  MS: POA_DESIGNATION.AttorneyInFact,
  MO: POA_DESIGNATION.AttorneyInFact,
  NY: POA_DESIGNATION.AttorneyInFact,
  NJ: POA_DESIGNATION.AttorneyInFact,
  ND: POA_DESIGNATION.AttorneyInFact,
  OK: POA_DESIGNATION.AttorneyInFact,
  OR: POA_DESIGNATION.AttorneyInFact,
  RI: POA_DESIGNATION.AttorneyInFact,
  TN: POA_DESIGNATION.AttorneyInFact,
  VT: POA_DESIGNATION.AttorneyInFact,
});
